import { AnyAction } from "redux";
import {
  FETCH_REFUND_PAGE_ERROR,
  FETCH_REFUND_PAGE_SUCCESS,
  REQUEST_FETCH_REFUND_PAGE,
} from "redux/actions/pages/refundpolicy";

const defaultState = {
  data: {},
  error: null,
  loading: false,
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_FETCH_REFUND_PAGE:
      return {
        ...state,
        loading: true,
      };
    case FETCH_REFUND_PAGE_SUCCESS:
      return {
        data: action.refund,
        error: null,
        loading: false,
      };
    case FETCH_REFUND_PAGE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
